import { API_URL, authenticatedFetch } from "../config/api";

export interface ProjectItemUpdate {
  id?: string;
  item_id: string;
  description: string;
  completion_delta?: number;
  previous_status?: string;
  new_status?: string;
  blockers?: string;
  hours_logged?: number;
  created_at?: string;
  updated_at?: string;
}

export const getProjectItemUpdates = async (
  projectId: string,
  itemId: string
): Promise<ProjectItemUpdate[]> => {
  const r = await authenticatedFetch(`${API_URL}/projects/${projectId}/items/${itemId}/updates`);
  if (!r.ok) {
    const text = await r.text();
    throw new Error(`Failed to fetch item updates: ${r.status} ${r.statusText} ${text}`);
  }
  const res = await r.json();
  if (Array.isArray(res)) return res;
  if (res?.results && Array.isArray(res.results)) return res.results;
  return [];
};

export const createProjectItemUpdate = async (
  projectId: string,
  itemId: string,
  data: ProjectItemUpdate
): Promise<ProjectItemUpdate> => {
  const r = await authenticatedFetch(`${API_URL}/projects/${projectId}/items/${itemId}/updates`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
  if (!r.ok) {
    const text = await r.text();
    throw new Error(`Failed to create item update: ${r.status} ${r.statusText} ${text}`);
  }
  return r.json();
};

export const getProjectItemUpdate = async (
  projectId: string,
  itemId: string,
  updateId: string
): Promise<ProjectItemUpdate> => {
  const r = await authenticatedFetch(`${API_URL}/projects/${projectId}/items/${itemId}/updates/${updateId}`);
  if (!r.ok) {
    const text = await r.text();
    throw new Error(`Failed to fetch item update: ${r.status} ${r.statusText} ${text}`);
  }
  return r.json();
};

export const updateProjectItemUpdate = async (
  projectId: string,
  itemId: string,
  updateId: string,
  data: ProjectItemUpdate
): Promise<ProjectItemUpdate> => {
  const r = await authenticatedFetch(`${API_URL}/projects/${projectId}/items/${itemId}/updates/${updateId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
  if (!r.ok) {
    const text = await r.text();
    throw new Error(`Failed to update item update: ${r.status} ${r.statusText} ${text}`);
  }
  return r.json();
};

export const deleteProjectItemUpdate = async (
  projectId: string,
  itemId: string,
  updateId: string
): Promise<void> => {
  const r = await authenticatedFetch(`${API_URL}/projects/${projectId}/items/${itemId}/updates/${updateId}`, {
    method: 'DELETE',
  });
  if (!r.ok) {
    const text = await r.text();
    throw new Error(`Failed to delete item update: ${r.status} ${r.statusText} ${text}`);
  }
};

